import { render, staticRenderFns } from "./GenericInputDocument.vue?vue&type=template&id=2e1cf924"
import script from "./GenericInputDocument.vue?vue&type=script&lang=js"
export * from "./GenericInputDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports